import {
  useReactTable,
  getCoreRowModel,
  flexRender,
  type ColumnDef,
} from '@tanstack/react-table'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'

type Row = {
  name: string
  status: string
  lastActivity: string
}

const columns: ColumnDef<Row>[] = [
  { accessorKey: 'name',         header: 'Name' },
  { accessorKey: 'status',       header: 'Status' },
  { accessorKey: 'lastActivity', header: 'Last Activity' },
]

export function DashboardTable() {
  const table = useReactTable<Row>({
    data: [],  // Phase 2: empty -- E2E tests in Phase 3 assert on column headers
    columns,
    getCoreRowModel: getCoreRowModel(),
  })

  return (
    <Table>
      <TableHeader>
        {table.getHeaderGroups().map((hg) => (
          <TableRow key={hg.id}>
            {hg.headers.map((header) => (
              <TableHead key={header.id}>
                {flexRender(header.column.columnDef.header, header.getContext())}
              </TableHead>
            ))}
          </TableRow>
        ))}
      </TableHeader>
      <TableBody>
        {table.getRowModel().rows.length === 0 && (
          <TableRow>
            <TableCell
              colSpan={columns.length}
              className="text-center text-muted-foreground py-8"
            >
              No data
            </TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
  )
}
